var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "idea-is-safe-list-item-wrapper" }, [
    _c("div", { staticClass: "d-flex align-items-center mb-1" }, [
      _c("img", { staticClass: "icon", attrs: { src: _vm.icon } }),
      _c(
        "p",
        {
          staticClass:
            "title d-flex align-items-center m-0 font-outfit-semi-bold",
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
    ]),
    _c("ul", [
      _c("li", [
        _c(
          "span",
          [_vm._v(" " + _vm._s(_vm.description) + " "), _vm._t("description")],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }